import { useState, useCallback } from "react";
import axios from "axios";

const useGroupedBet = () => {
  const [groupedBetData, setGroupedBetData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchGroupedBet = useCallback(
    async (groupedBetId, evMode = true, excludeBookies = [], bookieWeights = "", includeEstimatesFo = false) => {
      if (!groupedBetId) {
        console.error("No groupedBetId provided");
        return;
      }

      setLoading(true);
      try {
        const url =
          window.location.hostname === "localhost"
            ? evMode
              ? `/groupedbet.json`
              : `/groupedbet-non-ev.json`
            : `${window.location.origin}/wp-json/bonusbank/v1/value-bets/`;

        const params = {
          grouped_bet_id: groupedBetId,
        };

        // Only add devig parameter if in evMode
        if (evMode) {
          params.devig = "True";

          // Add exclude_bookies parameter if there are bookies to exclude
          if (excludeBookies && excludeBookies.length > 0) {
            params.exclude_bookies = excludeBookies.join(",");
          }
          
          // Add bookie_weights parameter if provided
          if (bookieWeights) {
            params.bookie_weights = bookieWeights;
          }

          // Add include_estimates_fo parameter if enabled
          if (includeEstimatesFo) {
            params.include_estimates_fo = true;
          }
        }

        const response = await axios.get(url, {
          params,
          headers: {
            "content-type": "application/json",
            "X-WP-Nonce": window.nonce,
          },
        });

        // For debugging
        console.log(
          `Fetched grouped bet data for ID: ${groupedBetId}, evMode: ${evMode}, excludeBookies: ${excludeBookies}, bookieWeights: ${bookieWeights}, includeEstimatesFo: ${includeEstimatesFo}`
        );

        // Transform non-EV mode data to match EV mode structure if needed
        if (!evMode && response.data?.bets) {
          const transformedData = {
            ...response.data,
            bets: response.data.bets.map((bet) => ({
              bookie: bet.bookie,
              bookieMarket: bet.bookieMarket || bet.market || "",
              selections: [
                {
                  rate: bet.rate,
                  updated: bet.updated,
                  source: bet.source,
                  bet: bet.bookieMarket || bet.market || "",
                },
              ],
            })),
          };
          setGroupedBetData(transformedData);
        } else {
          setGroupedBetData(response.data);
        }

        setError(null);
      } catch (err) {
        console.error("Error fetching grouped bet:", err);
        setError(err);
        setGroupedBetData(null);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  return { groupedBetData, loading, error, fetchGroupedBet };
};

export default useGroupedBet;
